export default "__VITE_ASSET__CZXEr6Cd__"